import { KeyValuePair } from '@common/data-models/misc/key-value-pair';
import { ServiceRecord } from '@common/data-models/service/service-record';
import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { ListData } from './list-data';
import { ObjectProperties } from './object-properties';

let metaData = {
    Actual: DataType.OBJECT,
    Estimated: DataType.STRING,
    HardHitBack: DataType.DATE,
    HardHitFront: DataType.DATE,
    ReadTime: DataType.NUMBER
};

KnownPropertyTypes.setFor(metaData);

export class ApiServiceRecord extends ServiceRecord {

    public Properties: { [id: string]: any } = {};

    public getOwnMetaData(): { [id: string]: number } {
        let objectKeys = Object.keys(this);
        let ret = {};
        for (let prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getOwnMetaData();
        let parentMetaData = super.getMetaData();

        // merge
        for (let p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        } else return super.getRawValue(field);
    }

    public static instance(data: any): ApiServiceRecord {
        let ret: ApiServiceRecord = Object.assign(new ApiServiceRecord, data);
        if (ret.LinkedRecords) {
            for (let i in ret.LinkedRecords) {
                ret.LinkedRecords[i] = Object.assign(new ApiServiceRecord, ret.LinkedRecords[i]);
                ret.LinkedRecords[i].instantiateChildren();
            }
            ret.instantiateChildren();
        }
        ret.instantiateChildren();
        return ret;
    }

    public instantiateChildren() {
        this.ListData = Object.assign(new ListData(), this.Properties);
        this.ObjectPropertiesCollection = new ObjectProperties(this.Properties, true);
    }
}
